const BASE_URL = "https://mediapi.onlinepharmaque.in/api/v1";
export default BASE_URL;